import { IData } from 'components/molecules/StockPositionGrid/types';

export const columns: IData[] = [
  {
    name: 'installation',
    align: 'left',
    sortingEnabled: true,
    width: 110,
    title: 'Instalação',
  },
  {
    name: 'itemCode',
    align: 'left',
    direction: 'asc',
    fullTitle: 'Código Item',
    width: 120,
    title: 'Cod. Item',
  },
  {
    name: 'itemDescription',
    align: 'left',
    width: 150,
    title: 'Descrição do item',
  },
  {
    name: 'model',
    align: 'left',
    width: 120,
    title: 'Modelo',
  },
  {
    name: 'supplier',
    align: 'left',
    width: 150,
    title: 'Fornecedor',
  },
  {
    name: 'materialClass',
    align: 'left',
    width: 150,
    title: 'Classe do Material',
  },
  {
    name: 'group',
    align: 'left',
    width: 150,
    title: 'Grupo',
  },
  {
    name: 'currentQuantity',
    align: 'left',
    width: 100,
    fullTitle: 'Quantidade Atual',
    title: 'Qnt. Atual',
    editingEnabled: true,
  },
  {
    name: 'minimumQuantity',
    align: 'left',
    width: 100,
    fullTitle: 'Quantidade Mínima',
    title: 'Qnt. Mín',
    editingEnabled: true,
  },
  {
    name: 'maximumQuantity',
    align: 'left',
    width: 100,
    fullTitle: 'Quantidade Máxima',
    title: 'Qnt. Máx',
    editingEnabled: true,
  },
  {
    name: 'orderNumber',
    align: 'left',
    width: 150,
    fullTitle: 'Número do pedido',
    title: 'Nº do Pedido',
  },
  {
    name: 'warehouse',
    align: 'left',
    width: 150,
    title: 'Almoxarifado',
  },
  {
    name: 'local',
    align: 'left',
    width: 150,
    title: 'Local',
  },
  {
    name: 'costCenter',
    align: 'left',
    width: 150,
    title: 'Centro de Custo',
  },
  {
    name: 'unityValue',
    align: 'left',
    width: 150,
    title: 'Valor Unit. R$',
  },
  {
    name: 'totalValue',
    align: 'left',
    width: 130,
    title: 'Valor Total R$',
  },
  {
    name: 'validity',
    align: 'left',
    sortingEnabled: true,
    width: 170,
    title: 'Validade',
    editingEnabled: true,
  },
  {
    name: 'leadtime',
    align: 'left',
    width: 140,
    title: 'Lead Time (dias)',
    editingEnabled: true,
  },
  {
    name: 'lifespan',
    align: 'left',
    width: 140,
    title: 'Vida útil (meses)',
    editingEnabled: true,
  },
  {
    name: 'validityLifespan',
    align: 'left',
    sortingEnabled: true,
    width: 170,
    title: 'Validade Vida útil',
  },
  {
    name: 'entryDate',
    align: 'left',
    width: 80,
    title: 'Data Entrada',
  },
  {
    name: 'removalDate',
    align: 'left',
    width: 80,
    title: 'Data Retirada',
  },
  {
    name: 'owner',
    align: 'left',
    width: 150,
    title: 'Proprietário EPI/EPC',
  },
  {
    name: 'situation',
    align: 'left',
    width: 140,
    title: 'Situação',
    editingEnabled: true,
  },
  {
    name: 'oracleCode',
    align: 'left',
    width: 140,
    title: 'Código Oracle',
    editingEnabled: true,
  },
];
